import { useQuery } from "react-query";
import { internalApi } from "@/react/helpers/urlHelpers";

export const useAdminStats = ({ space }) => {
  const {
    data,
    isLoading,
    refetch: refetchStats,
  } = useQuery(
    internalApi.courses.adminSummary({
      courseId: space?.id,
    }),
    {
      enabled: !!space?.id,
      refetchOnWindowFocus: false,
    },
  );

  return { data, isLoading, refetchStats };
};
